<template>
  <div class="m_index">
    <Header v-show="showHeader"/>
      <router-view @reRenderIndex="reRenderIndex"/>
    <Footer />
  </div>
</template>
<script>
import Header from './header'
import Footer from './footer'
export default {
  components: { Header, Footer },
  data() {
    return {
      showHeader: true
    }
  },
  methods: {
    reRenderIndex(value) {
      this.showHeader = value
    }
  }
}
</script>
<style lang="less">
.m_index {
  width: 100%;
  height: 100vh;
}
.van-popup--right {
  top: 0 !important;
  transform: translate3d(0, 0, 0) !important;
}
</style>

